export const ROUTE_PATH = '/parking-whitelist/static';

export const FEATURE_NAME = 'parkingWhitelistStaticFilterPage';
